module.exports = __webpack_public_path__ + "img/arm-stubby-claw.eae016b3.png";